import React from 'react'
import { I18n } from 'react-redux-i18n'

import FilterIcon from '../../icons/filter.svg'
import FilterInfo from './FilterInfo'

class CompositionFilter extends React.Component {
  showFilterInfo () {
    this.props.showModal(I18n.t('compositions.filterInfoTitle'), <FilterInfo/>, '50%')
  }

  render () {
    return (
      <div
        className="composition-filter-wrap qw-display-none qw-flex qw-items-center qw-justify-center qw-cursor-pointer"
        onClick={() => this.showFilterInfo()}>
        <FilterIcon className="qw-icon-medium"/> <span
        className="filter-label qw-font-size-body qw-line-height-body qw-color-text-body qw-capitalize">{I18n.t('compositions.filter')}</span>
      </div>
    )
  }
}

export default CompositionFilter



// WEBPACK FOOTER //
// ./src/app/components/compositions/CompositionFilter.js